import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { EmpresaComboComponent } from './empresa-combo/empresa-combo.component';

@NgModule({
  imports: [CommonModule, FormsModule, PoModule],
  declarations: [EmpresaComboComponent],
  exports: [EmpresaComboComponent],
})
export class SharedModule {}
